import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';

const BlogDetail = () => {


  const location = useLocation();
  let initial = {
    "blog_title": "",
    "blog_category": "",
    "blog_category_id": "",
    "blog_description": "",
    "blog_content": "",
    "img_url": "",
  }
  const [blogData, setBlogData] = useState(initial);


  const getBlogData = async (blogId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/BlogMaster/blogDetail?blogId=${blogId}`, config)
      if (response.response && response.response.data.errors) {
        console.log(response.response?.data?.errors)
      }

      if (response.status === true) {
        console.log(response.blogMasterDataByID)
        setBlogData(response.blogMasterDataByID ? response.blogMasterDataByID : blogData)
      }
      else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  };

  useEffect(() => {
    if (location.state) {
      getBlogData(location.state.blogId)
    }
  }, [location.state]);


  return (
    <>
      {/* Breadcrumb Section Start */}
      <section className="breadscrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadscrumb-contain">
                <h2>{blogData.blog_title}</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="index-2.html">
                        <i className="fa-solid fa-house" />
                      </a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Blogs
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Breadcrumb Section End */}
      <section className="blog-section section-b-space">
        <div className="container-fluid-lg">
          <div className="row g-sm-4 g-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 ratio_50">
  <div
    className="blog-detail-image rounded-3 mb-4 bg-size blur-up lazyloaded"
    style={{
      backgroundImage: `url(${process.env.REACT_APP_API_BASE_URL + blogData.img_url})`,
      backgroundSize: "cover",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      display: "block"
    }}
  >
    <div className="blog-image-contain">
      <ul className="contain-list">
        <li>{blogData.blog_category}</li>
      </ul>
      <h2>{blogData.blog_title}</h2>
      {/* <ul className="contain-comment-list">
        <li>
          <div className="user-list">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-user"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx={12} cy={7} r={4} />
            </svg>
            <span>Caroline</span>
          </div>
        </li>
        <li>
          <div className="user-list">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-calendar"
            >
              <rect x={3} y={4} width={18} height={18} rx={2} ry={2} />
              <line x1={16} y1={2} x2={16} y2={6} />
              <line x1={8} y1={2} x2={8} y2={6} />
              <line x1={3} y1={10} x2={21} y2={10} />
            </svg>
            <span>April 19, 2022</span>
          </div>
        </li>
        <li>
          <div className="user-list">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-message-square"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            <span>82 Comment</span>
          </div>
        </li>
      </ul> */}
    </div>
  </div>
  <div className="blog-detail-contain bg-white p-3">

  <div className="blog-details-quote">
      <h3>
        {blogData.blog_description}
      </h3>
      {/* <h5>- Denny Dose</h5> */}
    </div>

  <div dangerouslySetInnerHTML={{ __html: blogData.blog_content }} className='editor inter-font'></div>
    {/* <p>
      <span className="first">S</span> {blogData.blog_content}
    </p> */}
   
    
   
  </div>
 
</div>

          </div>
        </div>
      </section>

    </>
  )
}

export default BlogDetail;